export default __webpack_public_path__ + "static/media/icons8-microsoft-excel.110815a7.svg";